<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<el-form :inline="true" :model="formInline" class="user-search">
				<el-form-item label="商品品牌：">
					<el-input clearable v-model="formInline.type" size="small" placeholder="请输入商品品牌名称" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="商品名称：">
					<el-input clearable v-model="formInline.name" size="small" placeholder="请输入商品名称" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="是否上线：">
					<el-select v-model="formInline.isOnline" size="small" placeholder="请选择是否上线">
						<el-option label="全部" :value="null"></el-option>
						<el-option label="是" :value="true"></el-option>
						<el-option label="否" :value="false"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item style="float: right; margin-right: 0">
					<el-button size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
					<el-button size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
					<el-button size="small" type="primary" class="el-icon-plus" @click="handleEdit()">新增</el-button>
					<!-- <my-column-filter :listColumns="listColumns" @hidePop="getCheckBox"></my-column-filter> -->
				</el-form-item>
			</el-form>
			<STable
				:columns="columnsData"
				:data="listData"
				:loading="loading"
				:row-key="'keyId'"
				border
				:tree-props="{ children: 'subList', hasChildren: 'hasChildren' }"
				@get-data="getListData"
				@handle-command="handleCommand"
				@row-dblclick="handleRowClick"
			>
				<template #rowNumber>
					<el-table-column label="序号" align="left" width="140">
						<template #default="scope">
							{{ scope.row.projectIndex }}
						</template>
					</el-table-column>
				</template>
				<template #isOnline>
					<el-table-column label="是否上线" align="center" width="120">
						<template #default="scope">
							<el-switch v-model="scope.row.isOnline" :active-value="true" :inactive-value="false" @change="handleIsOnlineChange(scope.row)"></el-switch>
						</template>
					</el-table-column>
				</template>
				<template #operation>
					<el-table-column label="操作" align="center" width="300">
						<template #default="scope">
							<el-button v-if="scope.row.subList === null || scope.row.subList.leng === 0" size="mini" type="primary" class="el-icon-circle-plus" @click="createGoodsInfo(scope.row)">
								创建商品
							</el-button>
							<el-button size="mini" type="" class="el-icon-plus" @click="handleEdit(scope.row, 3)">新增</el-button>
							<el-button size="mini" type="danger" class="el-icon-delete" @click="deleteInfo(scope.row)">删除</el-button>
						</template>
					</el-table-column>
				</template>
			</STable>
			<!-- 分页组件 -->
			<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
		</topTab>
		<!-- 编辑 -->
		<edit ref="edit"></edit>
		<paramsAccess ref="paramsAccess"></paramsAccess>
	</div>
</template>

<script>
import { GetGoodsTypeTreePageList, DeleteGoodsType, SetGoodsTypeIsOnline } from "@/api/baseDataApi.js";
import edit from "./edit";
import paramsAccess from "./paramsAccess.vue";
export default {
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "商品品牌列表"
				}
			],
			pageShow: true,
			loading: false, // 显示加载
			listData: [],
			selectionList: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				type: "",
				name: "",
				isOnline: null
			},
			columnsData: [], //显示列
			listColumns: [
				{
					slot: "rowNumber",
					label: "序号",
					align: "center",
					width: "120",
					isKeep: true
				},
				{
					prop: "type",
					label: "商品品牌",
					align: "center",
					isKeep: true,
					minWidth: "120"
				},
				{
					prop: "name",
					label: "商品名称",
					align: "center",
					minWidth: "150"
				},
				{
					prop: "unit",
					align: "center",
					label: "单位",
					minWidth: "60"
				},
				{
					prop: "costMoney",
					align: "center",
					label: "成本价(元)",
					minWidth: "90",
					isMoney: true,
					moneyType: "expense"
				},
				{
					slot: "isOnline",
					align: "center",
					label: "是否上线",
					minWidth: "60"
				},
				{
					prop: "creator",
					align: "center",
					label: "创建人",
					minWidth: "120"
				},
				{
					prop: "createTime",
					label: "创建时间",
					align: "center",
					minWidth: "120"
				},
				{
					prop: "editor",
					label: "维护人",
					align: "center",
					minWidth: "120"
				},
				{
					prop: "updateTime",
					label: "维护时间",
					align: "center",
					minWidth: "120"
				},
				{
					slot: "operation",
					isKeep: true,
					align: "center",
					label: "操作"
				}
			]
		};
	},
	// 注册组件
	components: {
		edit,
		paramsAccess
	},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.getListData();
	},
	computed: {},
	methods: {
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		changePages() {},
		handleCommand(command) {
			// 1编辑
			switch (command.command) {
				case "1":
					this.createGoodsInfo(command.rowData);
					break;
				case "2":
					this.handleEdit(command.rowData, 3);
					break;
				case "4":
					this.deleteInfo(command.rowData);
					break;
				default:
					console.log(command);
			}
		},

		// 双击行数据
		handleRowClick(row) {
			this.$refs.edit.editShow(row, 2);
		},
		//显示编辑界面
		handleEdit(row, type = 1) {
			this.$refs.edit.editShow(row, type);
		},
		// 创建商品
		createGoodsInfo(row) {
			this.$refs.paramsAccess.paramsAccess(row);
		},
		// 删除
		deleteInfo(row) {
			this.$confirm("确定要删除【" + row.name + "】吗?", "信息", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				let parmter = {
					keyId: row.keyId
				};
				DeleteGoodsType(parmter)
					.then((res) => {
						if (res.code === 1) {
							this.$message({
								type: "success",
								message: "已删除!"
							});
							this.getListData();
						} else {
							this.$message({
								type: "info",
								message: res.msg
							});
						}
					})
					.catch((err) => {
						this.loading = false;
						this.$message.error("删除失败，请稍后再试！");
					});
			});
		},
		// 获取列表
		getListData() {
			this.loading = true;
			GetGoodsTypeTreePageList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
						this.addIndex();
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				})
				.finally(() => {
					this.loading = false;
				});
		},
		addIndex() {
			this.listData.forEach((node, i) => {
				this.getProjectIndex(node, "", i);
			});
		},
		getProjectIndex(node, parentIndex, index) {
			const projectIndex = parentIndex ? `${parentIndex}.${index + 1}` : `${index + 1}`;
			this.$set(node, "projectIndex", projectIndex);
			if (node.subList) {
				node.subList.forEach((child, i) => {
					this.getProjectIndex(child, projectIndex, i);
				});
			}
		},
		// 重置
		clearAll() {
			this.$data.formInline = this.$options.data.call(this).formInline;
			this.search();
		},
		inputChange(val) {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		handleIsOnlineChange(row) {
			let parmter = {
				keyId: row.keyId,
				isUse: row.isOnline
			};
			SetGoodsTypeIsOnline(parmter)
				.then((res) => {
					if (res.code === 1) {
						this.$message({
							type: "success",
							message: "已更新!"
						});
						this.getListData();
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("更新失败，请稍后再试！");
				});
		}
	}
};
</script>

<style scoped></style>
